import { Injectable } from '@angular/core';

import { GlobalMessageService, GlobalMessageType, Translatable } from '@spartacus/core';

@Injectable({
  providedIn: 'root',
})
/**
 * @description Facade class for the GlobalMessageService
 */
export class DpMessageService {
  constructor(private readonly globalMessageService: GlobalMessageService) {}

  showInfo(text: string | Translatable, time?: number): void {
    this.globalMessageService.add(text, GlobalMessageType.MSG_TYPE_INFO, time);
  }

  removeInfo(): void {
    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_INFO);
  }

  showConfirmation(text: string | Translatable, time?: number): void {
    this.globalMessageService.add(text, GlobalMessageType.MSG_TYPE_CONFIRMATION, time);
  }

  showWarning(text: string | Translatable, time?: number): void {
    this.globalMessageService.add(text, GlobalMessageType.MSG_TYPE_WARNING, time);
  }

  showError(text: string | Translatable, time?: number): void {
    this.globalMessageService.add(text, GlobalMessageType.MSG_TYPE_ERROR, time);
  }

  removeError(): void {
    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_ERROR);
  }
}
